import { AtlassianJiraConfluenceGridBaseDataProvider } from '../dataProvider/AtlassianJiraConfluenceGridBaseDataProvider';
import { API_TYPE_NIRVANA } from '../../../../../webcomponents.constants';
import { BaseWebComponentDataProviderFactory } from '../../../../../framework/BaseWebComponentDataProviderFactory';

export class AtlassianJiraConfluenceGridDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, AtlassianJiraConfluenceGridBaseDataProvider);
  }
}
